var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { CopyConfigureViewDto } from '../../../../../shared/service-proxies/service-proxies';
var CopyConfigureViewModalComponent = /** @class */ (function (_super) {
    __extends(CopyConfigureViewModalComponent, _super);
    function CopyConfigureViewModalComponent(injector, bsModalRef) {
        var _this = _super.call(this, injector) || this;
        _this.bsModalRef = bsModalRef;
        _this.active = false;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(CopyConfigureViewModalComponent.prototype, "configId", {
        get: function () {
            return this.args.configureId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CopyConfigureViewModalComponent.prototype, "configureViewModel", {
        get: function () {
            return this.args.configureView;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CopyConfigureViewModalComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    CopyConfigureViewModalComponent.prototype.save = function () {
        var saveViewModel = new CopyConfigureViewDto();
        saveViewModel.name = this.configureViewModel.name;
        saveViewModel.configureId = this.configId;
        saveViewModel.copyedViewId = this.configureViewModel.id;
        this.close(saveViewModel);
    };
    CopyConfigureViewModalComponent.prototype.close = function (view) {
        this.bsModalRef.hide();
        this._onClosed.next(view);
        this._onClosed.complete();
        this.active = false;
    };
    CopyConfigureViewModalComponent.prototype.ngOnInit = function () {
        this.active = true;
    };
    __decorate([
        Input()
    ], CopyConfigureViewModalComponent.prototype, "args", void 0);
    CopyConfigureViewModalComponent = __decorate([
        Component({
            selector: 'copy-configure-view-modal',
            template: "<form *ngIf=\"active\" #viewModalForm=\"ngForm\" novalidate (ngSubmit)=\"save()\" bs-modal-drag> <div class=\"modal-header\"> <h4 class=\"modal-title\"> <span>{{lc(\"CopyConfigureView\")}}</span> </h4> <button type=\"button\" class=\"close pull-right\" aria-label=\"Close\" (click)=\"close()\"> <span aria-hidden=\"true\">&times;</span> </button> </div> <div class=\"modal-body\"> <div class=\"modal-body-content\"> <div class=\"form-group\"> <label> <i class=\"star\">*</i>{{lc(\"ConfigureViewName\")}} </label> <input #nameInput type=\"text\" name=\"ConfigureViewName\" class=\"form-control fc-Form\" autoFocus #ConfigureViewName=\"ngModel\" [(ngModel)]=\"configureViewModel.name\" required pattern=\"^[\u4e00-\u9fa5a-zA-Z0-9\_\-]+$\" [maxLength]=\"20\"/> </div> <div class=\"row\"> <div class=\"col-xs-12\"> <div [hidden]=\"viewModalForm.form.valid || viewModalForm.form.pristine\"> <ul class=\"help-block text-danger\" *ngIf=\"ConfigureViewName.errors\"> <li [hidden]=\"!ConfigureViewName.errors.required\">{{lc(\"NameRequired\")}}</li> <li [hidden]=\"!ConfigureViewName.errors.pattern\">{{lc(\"NameHasSpecialCharacters\")}}</li> </ul> </div> </div> </div> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn fc-btn btn-cancel\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> <button type=\"submit\" class=\"btn fc-btn btn-save\" [disabled]=\"!viewModalForm.form.valid\"> <i class=\"fa fa-save\"></i> <span>{{l(\"Save\")}}</span> </button> </div> </form> "
        })
    ], CopyConfigureViewModalComponent);
    return CopyConfigureViewModalComponent;
}(ConfigureComponentBase));
export { CopyConfigureViewModalComponent };
